import { render, staticRenderFns } from "./MessageBody.vue?vue&type=template&id=5fd9fed8&scoped=true"
import script from "./MessageBody.vue?vue&type=script&lang=js"
export * from "./MessageBody.vue?vue&type=script&lang=js"
import style0 from "./MessageBody.vue?vue&type=style&index=0&id=5fd9fed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd9fed8",
  null
  
)

export default component.exports